// @Library
import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit';

// @Utils
import { axiosSystem } from '../../../utils/api';

// @Models
import { ICountryRequest } from '../../../models';

// !--- INIT HANDLER ---!
const handleGetCountries: AsyncThunkPayloadCreator<ICountryRequest[], undefined, {}> = async (
  payload,
  { rejectWithValue },
) => {
  try {
    const response = await axiosSystem.get<ICountryRequest[]>('country/estimates-country');
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response.data);
  }
};
// !--- END HANDLER ---!

// !--- INIT THUNKS ---!
export const getCountries = createAsyncThunk('country/getCountries', handleGetCountries);

// !--- END THUNKS ---!
